// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agreements-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  margin-bottom: 24px;
  text-align: center;
}

.pdf-container {
  margin-bottom: 40px;
}

.pdf-title {
  text-align: center;
  margin-bottom: 12px !important;
}

.pdf-description {
  text-align: center;
  margin-bottom: 20px;
  color: rgba(0, 0, 0, 0.65);
}

.pdf-iframe {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .agreements-container {
    padding: 12px;
  }
  
  .pdf-iframe {
    height: 500px;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/Agreements/Agreements.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".agreements-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.section-title {\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.pdf-container {\n  margin-bottom: 40px;\n}\n\n.pdf-title {\n  text-align: center;\n  margin-bottom: 12px !important;\n}\n\n.pdf-description {\n  text-align: center;\n  margin-bottom: 20px;\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.pdf-iframe {\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .agreements-container {\n    padding: 12px;\n  }\n  \n  .pdf-iframe {\n    height: 500px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
